import React from 'react';

const Header = () => {
  return (
    <header className="header">
      <h1>家簿</h1>
    </header>
  );
};

export default Header;